import rootStore from "csi/state/rootStore";
import Button from "designSystem/components/button/Button";
import FlexColumn from "designSystem/components/flex/FlexColumn";
import { Placeholder } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import SnapshotEmptyIcon from "../icon/SnapshotEmptyIcon";

export const SnapshotEmptyPlaceholder = observer(() => {
	const { toggleGenerateImagesPage } = rootStore.threeDStore.snapshotsStore;
	return (
		<FlexColumn justifyContent="center">
			<Placeholder
				subtitleMargin={6}
				subtitleProps={{ res: "SnapshotPlaceholderSubtitle" }}
				titleProps={{ res: "SnapshotPlaceholderTitle" }}
			>
				{{
					actions:
						<Button
							design="primary"
							onClick={toggleGenerateImagesPage}
							res="GenerateImages"
						/>
					,
					image:
                		<SnapshotEmptyIcon />
					,
				}}
			</Placeholder>
		</FlexColumn>
	);
});